import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames'

export default class TabContent extends Component {

  static propTypes = {
    active: PropTypes.string,
    renderTab: PropTypes.func.isRequired,
    tabs: PropTypes.array,
  }

  renderTab(value) {
    const { active } = this.props
    const key = typeof value === 'string' ? value : value.title
    return (
      <div
        key={key}
        className={classNames('tab-pane', { active: active === value })}
      >
        {this.props.renderTab(value)}
      </div>
    )
  }

  render() {
    const { tabs } = this.props
    return (
      <div className="vertical v-scrollable tab-content">
        {tabs.map(({ value }) => this.renderTab(value))}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/TabContent.js